<template lang="pug">
div.blog-page
  public-navbar
  // Hero Section
  v-parallax(
    src="https://images.unsplash.com/photo-1556795573-1f36b83594f6?q=80&w=1200&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D"
    :height="$vuetify.breakpoint.smAndDown ? 400 : 500"
        class="parallax-header"
  )
    .parallax-overlay
    v-container(fill-height)
      v-row(align="center" justify="center")
        v-col(cols="12" md="8" class="text-center")
          h1.text-h2.font-weight-bold.white--text.text-shadow Blog Gastronómico
          p.text-h6.white--text.text-shadow Descubre las últimas tendencias y novedades del mundo culinario
          v-row.mb-4
            v-col(cols="12")
              .d-flex.flex-wrap.align-center
                // Chips de tags seleccionados
                .d-flex.flex-wrap.align-center.mb-2(v-if="selectedTags.length")
                  v-chip(
                    v-for="tag in selectedTags"
                    :key="tag"
                    class="mr-2 mb-2"
                    close
                    @click:close="removeTag(tag)"
                  ) {{ tag }}
                v-text-field(
                  v-model="search"
                  prepend-inner-icon="mdi-magnify"
                  label="Buscar artículos"
                  dark
                  outlined
                  dense
                  hide-details
                  background-color="rgba(255,255,255,0.15)"
                  clearable
                  class="flex-grow-1"
                )

  v-container(class="mt-n12 pb-16")
    // Filters
    v-card(elevation="6" class="mb-6")
      v-card-text.py-2
        v-row(align="center")
          v-col(cols="12" sm="4")
            v-select(
              v-model="selectedCategory"
              :items="categories"
              label="Categoría"
              outlined
              hide-details
              dense
              clearable
            )
          v-col(cols="12" sm="8")
            v-chip-group(
              multiple
              column
              show-arrows
            )
              v-chip(
                v-for="tag in allTags"
                :key="tag"
                :value="tag"
                :input-value="selectedTags.includes(tag)"
                filter
                outlined
                @click="toggleTag(tag)"
              ) {{ tag }}

    // Blog Grid
    v-row
      v-col(
        v-for="article in filteredArticles"
        :key="article._id"
        cols="12"
        sm="6"
        md="4"
      )
        v-hover(v-slot="{ hover }")
          v-card(
            :elevation="hover ? 8 : 2"
            :class="{'on-hover': hover}"
            @click="viewArticle(article)"
          )
            v-img(
              :src="article.image"
              height="200"
              :class="{'on-hover': hover}"
            )
            v-card-title {{ article.title }}
            v-card-subtitle
              .d-flex.align-center
                v-icon(small) mdi-calendar
                span.ml-1 {{ formatDate(article.publishedAt) }}
                v-divider(vertical class="mx-2")
                v-icon(small) mdi-account
                span.ml-1 {{ article.author?.name }}
            
            v-card-text
              p.mb-2.text-truncate {{ article.description }}
              .d-flex.flex-wrap
                v-chip(
                  x-small
                  class="mr-1 mb-1"
                  :color="getCategoryColor(article.category)"
                  label
                ) {{ article.category }}
                v-chip(
                  v-for="tag in article.tags"
                  :key="tag"
                  x-small
                  class="mr-1 mb-1"
                  outlined
                  @click.stop="toggleTag(tag)"
                ) {{ tag }}
            
            v-card-actions
              v-spacer
              v-btn(
                text
                color="primary"
                :to="'/blog/' + article.slug"
              ) Leer más
              v-menu(offset-y)
                template(v-slot:activator="{ on, attrs }")
                  v-btn(
                    icon
                    v-bind="attrs"
                    v-on="on"
                  )
                    v-icon mdi-share-variant
                template(v-slot:default)
                  v-list
                    v-list-item(
                      v-for="social in socialShare"
                      :key="social.network"
                      @click="shareArticle(article, social.network)"
                    )
                      v-list-item-icon
                        v-icon(:color="social.color") {{ social.icon }}
                      v-list-item-title {{ social.text }}

    // Newsletter Subscription
    v-card(class="mt-6" color="primary" dark)
      v-card-text.text-center
        h2.text-h5.mb-2 ¡Suscríbete a nuestro newsletter!
        p.mb-4 Recibe las últimas novedades gastronómicas en tu email
        v-row(justify="center")
          v-col(cols="12" sm="6" md="4")
            v-form(ref="newsletterForm" v-model="newsletterValid" @submit.prevent="subscribeNewsletter")
              v-text-field(
                v-model="newsletterEmail"
                label="Tu email"
                :rules="emailRules"
                outlined
                dense
                hide-details
                class="mb-4"
              )
              v-btn(
                color="secondary"
                :disabled="!newsletterValid"
                type="submit"
                block
              ) Suscribirme
</template>

<script>
import { format } from 'date-fns';
import { es } from 'date-fns/locale';
import { 
  HomeIcon,
  CalendarIcon,
  FileTextIcon,
  BriefcaseIcon,
  UserPlusIcon
} from 'vue-feather-icons'
import PublicNavbar from '@/components/layout/PublicNavbar.vue'
import { mapState, mapActions } from 'vuex'

export default {
  name: 'Blog',

  components: {
    HomeIcon,
    CalendarIcon,
    FileTextIcon,
    BriefcaseIcon,
    UserPlusIcon,
    PublicNavbar
  },

  data: () => ({
    search: '',
    mobileMenuOpen: false,
    selectedCategory: null,
    selectedTags: [],
    selectedRestaurant: null,
    newsletterValid: false,
    newsletterEmail: '',
    isSubscribing: false,
    emailRules: [
      v => !!v || 'El email es requerido',
      v => /.+@.+\..+/.test(v) || 'Email inválido'
    ],
    categories: [
      'Nuevas Aperturas',
      'Eventos Especiales',
      'Menús Destacados',
      'Entrevistas',
      'Recetas',
      'Tips & Consejos'
    ],
    socialShare: [
      { network: 'facebook', icon: 'mdi-facebook', color: '#1877F2', text: 'Facebook' },
      { network: 'twitter', icon: 'mdi-twitter', color: '#1DA1F2', text: 'Twitter' },
      { network: 'whatsapp', icon: 'mdi-whatsapp', color: '#25D366', text: 'WhatsApp' }
    ]
  }),

  computed: {
    ...mapState('blog', ['articles', 'loading', 'restaurants']),
    
    filteredArticles() {
      return this.articles.filter(article => {
        // Asegurar que article.tags sea un array y normalizar
        const articleTags = Array.isArray(article.tags) 
          ? article.tags.map(tag => tag.toLowerCase())
          : []

        // Filtro de búsqueda
        if (this.search) {
          const searchLower = this.search.toLowerCase()
          const matchTitle = article.title.toLowerCase().includes(searchLower)
          const matchDescription = article.description.toLowerCase().includes(searchLower)
          const matchContent = article.content.toLowerCase().includes(searchLower)
          if (!matchTitle && !matchDescription && !matchContent) return false
        }

        // Filtro de categoría
        if (this.selectedCategory && article.category !== this.selectedCategory) {
          return false
        }

        // Filtro de tags
        if (this.selectedTags.length > 0) {
          const selectedTagsLower = this.selectedTags.map(tag => tag.toLowerCase())
          return selectedTagsLower.some(selectedTag => articleTags.includes(selectedTag))
        }

        return true
      })
    },

    allTags() {
      const tagsSet = new Set()
      this.articles.forEach(article => {
        if (Array.isArray(article.tags)) {
          article.tags.forEach(tag => tagsSet.add(tag))
        }
      })
      return Array.from(tagsSet).sort()
    }
  },

  methods: {
    ...mapActions('blog', ['fetchArticles']),

    async loadArticles() {
      try {
        const params = {}
        if (this.selectedRestaurant) {
          params.restaurant = this.selectedRestaurant
        }
        await this.fetchArticles(params)
      } catch (error) {
        this.$toast.error('Error al cargar los artículos')
      }
    },

    formatDate(date) {
      return format(new Date(date), "d 'de' MMMM, yyyy", { locale: es });
    },

    getCategoryColor(category) {
      const colors = {
        'Nuevas Aperturas': 'success',
        'Eventos Especiales': 'primary',
        'Menús Destacados': 'warning',
        'Entrevistas': 'info',
        'Recetas': 'purple',
        'Tips & Consejos': 'orange'
      };
      return colors[category] || 'grey';
    },

    viewArticle(article) {
      this.$router.push(`/blog/${article.slug}`);
    },

    shareArticle(article, network) {
      const url = `${window.location.origin}/blog/${article.slug}`;
      const text = article.title;

      const shareUrls = {
        facebook: `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(url)}`,
        twitter: `https://twitter.com/intent/tweet?text=${encodeURIComponent(text)}&url=${encodeURIComponent(url)}`,
        whatsapp: `https://wa.me/?text=${encodeURIComponent(`${text} ${url}`)}`
      };

      window.open(shareUrls[network], '_blank');
    },

    toggleTag(tag) {
      const index = this.selectedTags.indexOf(tag)
      if (index === -1) {
        this.selectedTags.push(tag)
      } else {
        this.selectedTags.splice(index, 1)
      }
    },

    removeTag(tagToRemove) {
      this.selectedTags = this.selectedTags.filter(tag => tag !== tagToRemove)
    },

    // Método para limpiar todos los tags
    clearAllTags() {
      this.selectedTags = []
    },

    async subscribeNewsletter() {
      if (!this.$refs.newsletterForm.validate()) return;

      this.isSubscribing = true;
      try {
        await this.$store.dispatch('newsletter/subscribe', this.newsletterEmail);
        this.$toast.success('¡Gracias por suscribirte!');
        this.newsletterEmail = '';
      } catch (error) {
        this.$toast.error('Hubo un error al suscribirte. Por favor, intentá nuevamente.');
      } finally {
        this.isSubscribing = false;
      }
    }
  },

  watch: {
    // Observar cambios en selectedTags para actualizar la URL
    selectedTags: {
      handler(newTags) {
        // Actualizar URL sin recargar la página
        if (newTags.length > 0) {
          this.$router.replace({ 
            query: { 
              ...this.$route.query,
              tag: newTags.join(',')
            }
          }).catch(() => {})
        } else {
          const query = { ...this.$route.query }
          delete query.tag
          this.$router.replace({ query }).catch(() => {})
        }
      },
      deep: true
    },

    // Observar cambios en la ruta para actualizar los tags seleccionados
    '$route.query': {
      immediate: true,
      handler(newQuery) {
        if (!this.loading) {
          // Manejar tags
          if (newQuery.tag) {
            const tags = newQuery.tag.split(',').map(t => t.trim()).filter(t => t)
            this.selectedTags = tags
          } else {
            this.selectedTags = []
          }

          // Manejar restaurante
          if (newQuery.restaurant !== this.selectedRestaurant) {
            this.selectedRestaurant = newQuery.restaurant || null
            this.loadArticles()
          }
        }
      }
    }
  },

  async created() {
    try {
      await this.loadArticles()
      
      // Procesar tags de la URL después de cargar los artículos
      const tagParam = this.$route.query.tag
      if (tagParam) {
        const tags = tagParam.split(',').map(t => t.trim()).filter(t => t)
        this.selectedTags = tags
      }
    } catch (error) {
      this.$toast.error('Error al cargar los artículos')
    } finally {
    }
  }
};
</script>

<style scoped>
.blog-page {
    background-color: #f5f5f5;
  }
.parallax-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(
    to bottom,
    rgba(0, 0, 0, 0.7) 0%,
    rgba(0, 0, 0, 0.5) 100%
  );
  z-index: 1;
}
.parallax-header {
    position: relative;
    width: 100%;
    background-size: cover;
    background-position: center;
  }
.v-parallax__content {
  position: relative;
  z-index: 2;
}

.text-shadow {
  text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.5);
}

.search-field {
  backdrop-filter: blur(5px);
}

.search-field :deep(.v-input__slot) {
  background: rgba(255, 255, 255, 0.15) !important;
}

.search-field :deep(.v-label),
.search-field :deep(.v-icon) {
  color: white !important;
}

.search-field :deep(.v-text-field__slot input) {
  color: white !important;
}

.search-field :deep(.v-text-field__slot input::placeholder) {
  color: rgba(255, 255, 255, 0.7) !important;
}

.v-card {
  transition: transform 0.2s;
}

.v-card.on-hover {
  transform: translateY(-4px);
}

.v-card .v-img {
  transition: transform 0.3s;
}

.v-card .v-img.on-hover {
  transform: scale(1.05);
}

@media (max-width: 600px) {
  .v-btn {
    min-height: 44px !important;
  }
  .v-input__append-outer {
      display: none!important;
  }
  .v-chip {
    height: 30px !important;
  }
  h1.text-h2.font-weight-bold.white--text.text-shadow {
    font-size: 2rem!important;
    padding-top: 80px!important;
  }
  p.text-h6.white--text.text-shadow {
      font-size: 1rem !important;
  }
}
header.v-sheet.theme--light.elevation-1.v-toolbar.v-toolbar--absolute.v-app-bar {
    box-shadow: none !important;
    border: none;
}
.v-app-bar a {
    text-decoration: none;
}
.theme--light.v-app-bar.v-toolbar.v-sheet {
    background-color: #f5f5f500;
  }
.parallax-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(
    to bottom,
    rgba(0, 0, 0, 0.7) 0%,
    rgba(0, 0, 0, 0.5) 100%
  );
  z-index: 1;
}
.text-center.col-md-8.col-12 {
    z-index: 4;
}
</style>